define(['jquery', 'knockout', 'selectize'], function ($, ko, selectize) {
    var inject_binding = function (allBindings, key, value) {
        //https://github.com/knockout/knockout/pull/932#issuecomment-26547528
        return {
            has: function (bindingKey) {
                return bindingKey == key || allBindings.has(bindingKey);
            },
            get: function (bindingKey) {
                var binding = allBindings.get(bindingKey);
                if (bindingKey == key) {
                    binding = binding ? [].concat(binding, value) : value;
                }
                return binding;
            },
        };
    };

    ko.bindingHandlers.selectize = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            if (!allBindingsAccessor.has('optionsText'))
                allBindingsAccessor = inject_binding(allBindingsAccessor, 'optionsText', 'name');
            if (!allBindingsAccessor.has('optionsValue'))
                allBindingsAccessor = inject_binding(allBindingsAccessor, 'optionsValue', 'id');
            if (typeof allBindingsAccessor.get('optionsCaption') == 'undefined')
                allBindingsAccessor = inject_binding(
                    allBindingsAccessor,
                    'optionsCaption',
                    'Choose...'
                );

            ko.bindingHandlers.options.update(
                element,
                valueAccessor,
                allBindingsAccessor,
                viewModel,
                bindingContext
            );

            var options = {
                valueField: allBindingsAccessor.get('optionsValue'),
                labelField: allBindingsAccessor.get('optionsText'), //,
                //searchField: allBindingsAccessor.get('optionsSearch')
            };

            // Merge passed options from data-bind, respecting wrapperClass/inputClass
            if (allBindingsAccessor.has('options')) {
                var passed_options = allBindingsAccessor.get('options');
                for (var attr_name in passed_options) {
                    options[attr_name] = passed_options[attr_name];
                }
            }

            // Set default classes only if they were not provided in options
            options.wrapperClass = options.wrapperClass || 'selectize-control';
            options.inputClass = options.inputClass || 'selectize-input';

            // Auto-resize dropdown width to fit the widest option
            var userOnDropdownOpen = options.onDropdownOpen;
            options.onDropdownOpen = function ($dropdown) {
                var $content = $dropdown.find('.selectize-dropdown-content');
                var $items = $content.children();
                if (!$items.length) {
                    if (userOnDropdownOpen) userOnDropdownOpen.call(this, $dropdown);
                    return;
                }

                // Temporarily remove width constraints to measure natural content width
                $dropdown.css({ width: 'auto', 'min-width': '0' });
                $content.css({ 'white-space': 'nowrap' });
                $items.css({ 'white-space': 'nowrap', overflow: 'visible' });

                var maxWidth = 0;
                $items.each(function () {
                    var w = this.scrollWidth || $(this).outerWidth();
                    if (w > maxWidth) maxWidth = w;
                });

                // Add padding for scrollbar and borders
                var contentWidth = maxWidth + 20;
                var controlWidth = this.$control.outerWidth();
                var finalWidth = Math.max(contentWidth, controlWidth);

                $dropdown.css({ width: finalWidth + 'px', 'min-width': controlWidth + 'px' });
                $content.css({ 'white-space': '' });
                $items.css({ 'white-space': '', overflow: '' });

                if (userOnDropdownOpen) userOnDropdownOpen.call(this, $dropdown);
            };

            var $select = $(element).selectize(options)[0].selectize;

            // Prevent memory leaks by cleaning up on DOM disposal
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $select.destroy();
            });

            if (typeof allBindingsAccessor.get('value') == 'function') {
                var val = allBindingsAccessor.get('value')();
                if (!$select.options[val]) {
                    $select.addItem(val);
                } else {
                    $select.setValue(val);
                }
                allBindingsAccessor.get('value').subscribe(function (new_val) {
                    if (!$select.options[new_val]) {
                        $select.addItem(new_val);
                    } else {
                        $select.setValue(new_val, true);
                    }
                });
            }

            if (typeof allBindingsAccessor.get('selectedOptions') == 'function') {
                var selected = allBindingsAccessor.get('selectedOptions')();
                $select.setValue(selected); // use setValue instead of looping addItem
                allBindingsAccessor.get('selectedOptions').subscribe(function (new_val) {
                    // Use setValue with array to keep selectedOptions in sync
                    $select.setValue(new_val, true);
                });
            }

            if (typeof init_selectize == 'function') {
                init_selectize($select);
            }

            if (typeof valueAccessor().subscribe == 'function') {
                valueAccessor().subscribe(
                    function (changes) {
                        // To avoid having duplicate keys, all delete operations will go first
                        var addedItems = new Array();
                        changes.forEach(function (change) {
                            switch (change.status) {
                                case 'added':
                                    addedItems.push(change.value);
                                    break;
                                case 'deleted':
                                    var itemId = change.value[options.valueField];
                                    if (itemId != null) $select.removeOption(itemId);
                            }
                        });
                        addedItems.forEach(function (item) {
                            $select.addOption(item);
                        });
                    },
                    null,
                    'arrayChange'
                );
            }
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            if (allBindingsAccessor.has('object')) {
                var optionsValue = allBindingsAccessor.get('optionsValue') || 'id';
                var value_accessor = valueAccessor();
                var selected_obj = $.grep(value_accessor(), function (i) {
                    if (typeof i[optionsValue] == 'function') var id = i[optionsValue];
                    else var id = i[optionsValue];
                    return id == allBindingsAccessor.get('value')();
                })[0];

                if (selected_obj) {
                    allBindingsAccessor.get('object')(selected_obj);
                }

                allBindingsAccessor.get('options') &&
                    $(element)
                        .next()
                        .find('.item')
                        .attr('title', allBindingsAccessor.get('options').title);
            }
        },
    };
});
